import { environment } from '../../../environments/environment';

export const ApiUrlConstants = {
  getAllCountryDetails: '/settings/getAllCountriesDetails',
  getAllCountryDetailsByRfqToken: '/settings/getAllCountriesDetailsByRfqToken',
  
  addIncotermsData:'/settings/addIncotermsData',

  getAllIncotermsBySupplierId:'/settings/getAllIncotermsBySupplierId',
  getAllIncotermsBySupplierIdByRfqToken:
    '/settings/getAllIncotermsBySupplierIdByRfqToken',

  fetchSupplierPaymentDetails:'/settings/fetchSupplierPaymentDetails',

  getSetupBundle:'/settings/getSetupBundle',
  getIncotermsBundle:'/settings/getIncotermsBundle',

  addPaymentDetails:'/settings/addPaymentDetails',

  updatePaymentDetails:'/settings/updatePaymentDetails',

  addModeOfTransport:'/settings/addModeOfTransport',

  addModeOfTransportToFreightForwarder:'/settings/addModeOfTransportToFreightForwarder',

  getModeofTransportByUserId:'/settings/getModeofTransportByUserId',

  getAllModeOfTransport:'/settings/getAllModeOfTransport',

  addPackaging:'/settings/addPackaging',

  addPackagingToFreightForwarder:'/settings/addPackagingToFreightForwarder',

  getPackagingByUserId:'/settings/getPackagingByUserId',

  getAllPackaging:'/settings/getAllPackaging',

  getSupplierCount: '/settings/getCount',

  getDashboardSupplierCounts: '/settings/dashboardSupplierCounts',

  getSupplierCountByBrand: '/settings/getCountByBrand',
  getSupplierCountByServiceCategory:'/settings/getSupplierCountByServiceCategory',

  getUserDetails: '/dashboard/getAdminDashboardUsersDetail',

  //#region User routes
  ResendTemporaryPassword: '/users/resendTemporaryPassword',

  currentUserLogin: '/users/login',

  // VSMPS SSO bridge — exchanges the IHMM-minted ssoToken for a portal session.
  verifyVsmpsSso: '/vsmps-sso/verify',

  resetUserPassword: '/users/resetUserPassword',

  forgotPassword: '/users/forgotPassword',

  setNewPasswordFromForgot: '/users/newPassword',

  GetUserDetailByToken: '/users/getDetailsByTokenId',

  LogoutCurrentUser: '/users/logout',

  getLoginUserDetails: '/users/getDetails',

  GetUserCategories: '/userCategories',

  /** Get user detail by logged user's email. */
  GetUserDetailByEmail: '/users/getDetailsByEmail',
  /** Update logged user's profile photo URL */
  updateProfilePhotoUrl: '/users/updateProfilePhotoUrl',
  //#endregion

  getPaginatedUserClasses: '',

  getRegistrationFormData: '/users/getRegistrationData',
  registerUser: '/users/signup', //This route to be changed to '/users/signup' when actual connection
  registerUserV2: '/users/signup/v2',

  // !Settings screen routes
  getAccountData: '/settings/accounts',
  getAboutData: '/settings/about',
  getBuyerAboutData: '/settings/buyer/about',
  getSupplierPortData: '/settings/supplierPortsById',
  getSupplierPortDataById: '/settings/supplierPortsById',
  getSupplierBranchData: '/settings/supplierBranches',
  supplierCatalogue: '/settings/catalogues',
  products: '/products', //!Same can be used to fetch single catalogue by passing id after,
  supplierProduct: '/settings/supplierProduct',
  createProduct: '/products/create',
  
  addMySupplierProduct: '/products/addMySupplierProduct',
  requestAddNewSupplierProduct: '/products/requestAddNewSupplierProduct',
  requestAddNewBuyerProduct: '/products/requestAddNewBuyerProduct',
  fetchAllBuyerProductChangeRequest: '/settings/fetchAllBuyerProductChangeRequest',
  rejectBuyerProductChangeRequest: '/settings/rejectBuyerProductChangeRequest',
  approveBuyerProductChangeRequest: '/products/approveBuyerProductChangeRequest',
  // Spare parts (MPS-225) — separate endpoints so the product ones above
  // keep their exact contract. Author: Akarsh Singh | 07-08-2026
  requestAddNewSpareProduct: '/products/requestAddNewSpareProduct',
  requestUpdateSpareProduct: '/products/requestUpdateSpareProduct',
  getSpareProductDetails: '/products/getSpareProductDetails',
  getProductTemplate: '/products/getProductTemplate',
  getVisibilityRules: '/products/getVisibilityRules',
  updateVisibilityRule: '/products/updateVisibilityRule',
  fetchAllSpareChangeRequest: '/products/fetchAllSpareChangeRequest',
  approveSpareChangeRequest: '/products/approveSpareChangeRequest',
  rejectSpareChangeRequest: '/products/rejectSpareChangeRequest',
  requestUpdateSupplierProduct: '/products/requestUpdateSupplierProduct',
  requestAddNewMarketplaceProduct:'/products/requestAddNewMarketplaceProduct',
  requestUpdateMarketplaceProduct:'/products/requestUpdateMarketplaceProduct',


  assignProduct: '/products/assign',
  assignService: '/services/assign',
  validateProductName: '/products/validateProductName',

  createCategory: '/categories/create',
  updateCategory: '/categories/update',
  fetchAllProductCategory: '/categories',
  fetchArchivedProductCategory: '/categories/fetchArchivedProductCategory',
  fetchAllPendingProductCategory:
    '/categories/productCategory/PendingForApproval',

  fetchAllServiceCategory: '/categories/serviceCategory',
  fetchArchivedServiceCategory: '/categories/fetchArchivedServiceCategory',
  fetchAllPendingServiceCategory:
    '/categories/serviceCategory/PendingForApproval',

  restoreArchivedCategory: '/categories/restore',
  approveCategory: '/categories/aprrove',
  bulkApproveCategory: '/categories/bulkApprove',

  createBrand: '/brands/create',
  updateBrand: '/brands/update',
  fetchAllBrand: '/brands',
  fetchArchivedBrand: '/brands/fetchArchivedBrand',
  restoreArchivedBrand: '/brands/restore',
  fetchAllPendingBrand: '/brands/PendingForApproval',
  approveBrand: '/brands/aprrove',
  
  addPortByAdmin:'/port/addPortByAdmin',
  updatePortByAdmin:'/port/updatePortByAdmin',
  restorePortByAdmin:'/port/restorePortByAdmin',
  importPortsByAdmin:'/port/importPortsByAdmin',

  addTaxDetails:'/users/addTaxDetails',
  updateTaxDetails:'/users/updateTaxDetails',
  getTaxDetails:'/users/getTaxDetails',
  getTaxDetailsByRfqToken:'/users/getTaxDetailsByRfqToken',
  importTaxDetails:'/users/importTaxDetails',

  addTaxDetailsBySupplier:'/users/addTaxDetailsBySupplier', 
  updateTaxDetailsBySupplier:'/users/updateTaxDetailsBySupplier',
  getTaxDetailsBySupplier:'/users/getTaxDetailsBySupplier',
  getTaxDetailsBySupplierByPoToken:'/users/getTaxDetailsBySupplierByPoToken',
  getTaxDetailsBySupplierByRfqToken:'/users/getTaxDetailsBySupplierByRfqToken',
  addTaxDetailsBySupplierByRfqToken:'/users/addTaxDetailsBySupplierByRfqToken',
  importTaxDetailsBySupplier:'/users/importTaxDetailsBySupplier',

  productAttachment: '/products/attachment',
  ServiceAttachment: '/services/attachment',
  DeleteServiceCertificate: '/services/deleteServiceCertificate',
  fetchServiceCertificateById: '/services/fetchServiceCertificateById',
  updateServiceCertificateById: '/services/updateServiceCertificate',
  getBulkProductAttachmentUrls: '/products/generateBulkUploadUrls',
  getBulkProductAttachmentUrlsByRfqToken: '/products/generateBulkUploadUrlsByRfqToken',
  productsBySupplier: '/settings/supplier/products',
  getAllCurrenciesByFliterKeyValue: '/settings/getAllCurrenciesByFliterValue',
  getAllCurrenciesByFliterKeyValueByRfqToken:
    '/settings/getAllCurrenciesByFliterValueByRfqToken',
  getAllCategoriesByFliterKeyValue: '/settings/getAllCategoriesByFliterValue',
  getAllSubCategoriesByFliterKeyValue:
    '/settings/getAllSubCategoriesByFliterValue',

  getAllServiceCategoriesByFliterKeyValue:
    '/settings/getAllServiceCategoryByFliterValue',
  getAllUomByFliterKeyValue: '/settings/getAllUomByFliterValue',
  getAllMtmlUomByFliterKeyValue: '/settings/getAllMtmlUomByFliterValue',
  getAllServiceApprovalClassByFliterValue:
    '/settings/getAllServiceApprovalClassByFliterValue',
  getAllBrandsByFliterKeyValue: '/settings/getAllBrandsByFliterValue',
  getAllCountriesByFilterKeyValue: '/settings/getAllCountriesByFliterValue',
  getAllRegionsByFilterKeyValue: '/settings/getAllRegionsByFliterValue',
  getAllRegionsByFilterKeyValueByRfqToken: '/settings/getAllRegionsByFliterValueByRfqToken',
  getAllCitiesByFilterKeyValue: '/settings/getAllCitiesByFliterValue',

  getAllCountryRegionCities: '/settings/getAllCountryRegionCities',

  getAllMembershipsByFliterKeyValue: '/settings/getAllMembershipsByFliterValue',
  getAllCertificatesByFliterKeyValue:
    '/settings/getAllCertificatesByFliterValue',
  getAllPortsByFliterKeyValue: '/settings/getAllPortsByFliterValue',
  getAllSDGCommitmentsByFliterKeyValue:
    '/settings/getAllSDGCommitmentsByFliterValue',

  getAllAutoCompleteVesselsByFliterValue:
    '/rfq/getAllAutoCompleteVesselsByFliterValue',

  getAllAutocompleteVesselFilterData:
    '/buyer/getAllAutocompleteVesselFilterData',

  getAllAutocompleteSupplierProductByFliterKeyValueAndSupplierId:
    '/settings/getAllSupplierProductByFliterValueAndSupplierId',
  getAllAutocompleteSupplierProductByFliterKeyValueAndSupplierIdByRfqToken:
    '/settings/getAllSupplierProductByFliterValueAndSupplierIdByRfqToken',

  catalogueProductOp: '/settings/catalogue/product',
  getSupplierData: '/settings/supplier/data',
  getMemberships: '/company/memberships',
  getCertificates: '/company/certificates',
  supplierBranchOp: '/supplier/branch',
  sustainabilityOp: '/settings/sustainability',
  organizationalPurposeOp: '/settings/sustainability/organizationalPurpose',
  isoCertificationOp: '/settings/sustainability/isoCertification',
  sustainabilityCommitmentOp: '/settings/sustainability/sustainableCommitments',
  importSustainableData:'/settings/sustainability/importSustainableData',
  ungcParticipationOp: '/settings/sustainability/ungcParticipations',
  additionalDocumentsOp: '/settings/sustainability/additionalDocuments',
  relevantLinksOp: '/settings/sustainability/relevantLinks',
  getImpaData: '/settings/impaproduct',
  supplierImpaproduct: '/settings/supplierImpaproduct',
  getSupplierSpareProducts: '/settings/getSupplierSpareProducts',
  getBrandCategory: '/settings/brandcategory',
  getServiceData: '/services',
  getSupplierServiceData: '/services/fetchSupplierService',
  getAllServiceData: '/services/standAloneService',
  createServiceCertificate: '/services/certificate/create',
  createService: '/services/create',
  supplierService: '/services/supplierService',
  addCompanyProductServiceDescription:
    '/company/productServiceDescription/create',
  getProductServiceDescription: '/company/productServiceDescription',
  getPortsByAdmin:'/port/getPortsByAdmin',
  exportPortsByAdmin:'/port/exportPortsByAdmin',

  getUomMtmlUomData:'/uomMtmlUom/getUomMtmlUomData',
  exportUomMtmlUomData:'/uomMtmlUom/exportUomMtmlUomData',
  addUomMtmlUomData:'/uomMtmlUom/addUomMtmlUomData',
  updateUomMtmlUomData:'/uomMtmlUom/updateUomMtmlUomData',
  archiveOrUnarchiveUomMtmlUomData:'/uomMtmlUom/archiveOrUnarchiveUomMtmlUomData',
  importUomMtmlUomData:'/uomMtmlUom/importUomMtmlUomData',

  

  getCatalogueDataById: '/settings/supplierCatalogue',
  CreateCatalogue: '/settings/supplierCatalogue/create',
  searchImpaItems: '/search/serchItems',

  searchImpaItemsMySupplier: '/search/searchItemsMySupplier',

  searchSuppliersForRfq: '/rfq/searchSuppliersForRfq',
  
  getGeoLocation: '/settings/supplierBranch/location',
  getSearchCountryPorts: '/settings/getAllCountriesPortsByFliterValue',

  getSupplierProfileData: '/supplier/supplierProfileData',
  getLimitedProfileData: '/supplier/supplierProfile',

  // Buyer KYC (Jira MPS-193)
  buyerKycGetLookups: '/buyer/kyc/lookups',
  buyerKycGetDashboard: '/buyer/kyc/dashboard',
  buyerKycGetApplication: '/buyer/kyc/application',
  buyerKycGetTimeline: '/buyer/kyc/timeline',
  buyerKycStart: '/buyer/kyc/start',
  buyerKycSaveOrg: '/buyer/kyc/saveOrg',
  buyerKycSaveBanking: '/buyer/kyc/saveBanking',
  buyerKycSaveDocument: '/buyer/kyc/saveDocument',
  buyerKycSaveCertification: '/buyer/kyc/saveCertification',
  buyerKycSubmit: '/buyer/kyc/submit',

  // Supplier KYC (Jira MPS-192)
  kycGetLookups: '/supplier/kyc/lookups',
  kycGetDashboard: '/supplier/kyc/dashboard',
  kycGetApplication: '/supplier/kyc/application',
  kycGetTimeline: '/supplier/kyc/timeline',
  kycStart: '/supplier/kyc/start',
  kycSaveOrg: '/supplier/kyc/saveOrg',
  kycSaveIdentifiers: '/supplier/kyc/saveIdentifiers',
  // MPS-263 KYC-103 — blank UBO declaration form.
  kycUboTemplate: '/supplier/kyc/uboDeclarationTemplate',
  kycSaveBanking: '/supplier/kyc/saveBanking',
  kycSaveDocument: '/supplier/kyc/saveDocument',
  kycSaveCertification: '/supplier/kyc/saveCertification',
  kycSubmit: '/supplier/kyc/submit',
  //Product PO token based KYC APIs (Jira MPS-261)
  kycGetLookupsByProductPoToken: '/supplier/kyc/productRfq/lookupsByPoToken',
  kycGetApplicationByProductPoToken: '/supplier/kyc/productRfq/applicationByPoToken',
  kycStartByProductPoToken: '/supplier/kyc/productRfq/startByPoToken',
  kycSaveOrgByProductPoToken: '/supplier/kyc/productRfq/saveOrgByPoToken',
  kycSaveIdentifiersByProductPoToken: '/supplier/kyc/productRfq/saveIdentifiersByPoToken',
  kycUboTemplateByProductPoToken: '/supplier/kyc/productRfq/uboDeclarationTemplate',
  kycSaveBankingByProductPoToken: '/supplier/kyc/productRfq/saveBankingByPoToken',
  kycSaveDocumentByProductPoToken: '/supplier/kyc/productRfq/saveDocumentByPoToken',
  kycSaveCertificationByProductPoToken: '/supplier/kyc/productRfq/saveCertificationByPoToken',
  kycSubmitByProductPoToken: '/supplier/kyc/productRfq/submitByPoToken',
  //Service PO token based KYC APIs (Jira MPS-261)
  kycGetLookupsByServicePoToken: '/supplier/kyc/serviceRfq/lookupsByPoToken',
  kycGetApplicationByServicePoToken: '/supplier/kyc/serviceRfq/applicationByPoToken',
  kycStartByServicePoToken: '/supplier/kyc/serviceRfq/startByPoToken',
  kycSaveOrgByServicePoToken: '/supplier/kyc/serviceRfq/saveOrgByPoToken',
  kycSaveIdentifiersByServicePoToken: '/supplier/kyc/serviceRfq/saveIdentifiersByPoToken',
  kycUboTemplateByServicePoToken: '/supplier/kyc/serviceRfq/uboDeclarationTemplate',
  kycSaveBankingByServicePoToken: '/supplier/kyc/serviceRfq/saveBankingByPoToken',
  kycSaveDocumentByServicePoToken: '/supplier/kyc/serviceRfq/saveDocumentByPoToken',
  kycSaveCertificationByServicePoToken: '/supplier/kyc/serviceRfq/saveCertificationByPoToken',
  kycSubmitByServicePoToken: '/supplier/kyc/serviceRfq/submitByPoToken',

  searchCategoryItems: '/search/searchCategory',
  searchBrandItems: '/search/searchBrand',
  getArchivedItems: '/settings/archivedItems',
  getDetailedArchivedItems: '/settings/detailedArchivedItems',
  restoreArchivedItems: '/settings/restoreArchivedItems',

  inviteUserBySupplier: '/users/supplier/createUser',
  updateUserDetails: '/users/supplier/updateUserDetails',
  
  fetchUserBySupplier: '/users/supplier/fetchUserBySupplierId',
  fetchUserListBundle: '/users/supplier/fetchUserListBundle',
  fetchSupplierUserByRfqId: '/users/fetchRfqSupplierUserByRfqId',
  assignSupplierUser: '/users/assignsupplieruser',
  assignRFQToBuyerUser: '/users/assignRFQToBuyerUser',
  assignPOToBuyerUser: '/users/assignPOToBuyerUser',
  assignPOToSupplierUser: '/users/assignPOToSupplierUser',
  assignQuoteToSupplierUser:'/users/assignQuoteToSupplierUser',
  getImpaDetailsforRfq: '/rfq/fetchImpaDetails',
  fetchSetupEmailsByUserId: '/users/fetchSetupEmailsByUserId',
  addUpdateVessel: '/buyer/vessel/create',
  deleteVessel: '/buyer/vessel/delete',
  importVessels: '/buyer/vessel/import',
  fetchVesselDataByUserId: '/buyer/vessel/fetchVesselData',
  fetchVesselFilterValues: '/buyer/vessel/fetchVesselFilterValues',
  // Admin · Buyer Vessels (MPS-222)
  adminBuyerVesselsOperators: '/buyer/admin/vessels/operators',
  adminBuyerVesselsKpis: '/buyer/admin/vessels/kpis',
  adminBuyerVesselsFleet: '/buyer/admin/vessels/fleet',

  addRecentSearchHistory: '/settings/CreateUserSearchHistory',
  fetchUserSearchHistory: '/settings/fetchUserSearchHistory',
  UpdateUserSearchHistory: '/settings/UpdateUserSearchHistory',

  createSupplierSetup: '/settings/createSupplierSetup',
  fetchSupplierSetup: '/settings/fetchSupplierSetup',
  fetchSupplierSetupByRfqToken: '/settings/fetchSupplierSetupByRfqToken',

  fetchUserInbox: '/users/fetchUserInbox',
  fetchBranchAddressFilterValues: '/buyer/fetchBranchAddressFilterValues',
  getUnreadMailCount: '/users/getUnreadMailCount',
  getTotalMailCount:'/users/getTotalMailCount',
  getTotalMailCountByInterval:'/users/getTotalMailCountByInterval',
  markAsRead: '/users/markAsRead',
  archiveMail: '/users/archiveMail',
  fetchAllRfqBySupplierId: '/rfq/fetchAllRfqBySupplierId',
  fetchAllServiceRfqBySupplierId: '/services/rfq/fetchAllServiceRfqBySupplierId',
  fetchAllServiceRfqByBuyerId: '/services/rfq/fetchAllServiceRfqByBuyerId',
  getCompareServiceSupplierQuotes: '/services/rfq/getCompareServiceSupplierQuotes',
  archiveServiceRfq: '/services/rfq/archive',
  unArchiveServiceRfq: '/services/rfq/unarchive',
  bulkArchiveServiceRfq: '/services/rfq/bulkArchive',
  bulkUnArchiveServiceRfq: '/services/rfq/bulkUnarchive',
  buyerArchiveServiceRfq: '/services/rfq/buyerArchive',
  buyerUnArchiveServiceRfq: '/services/rfq/buyerUnarchive',
  buyerBulkArchiveServiceRfq: '/services/rfq/buyerBulkArchive',
  buyerBulkUnArchiveServiceRfq: '/services/rfq/buyerBulkUnarchive',
  cancelBuyerServiceRfq: '/services/rfq/buyerCancel',
  generateBuyerServiceRfqAttachment: '/services/rfq/generateBuyerServiceRfqAttachment',
  fetchBuyerServiceRfqDetailsForExcel: '/services/rfq/fetchBuyerServiceRfqDetailsForExcel',
  exportAllServiceRfq: '/services/rfq/exportAll',
  exportBuyerServiceRfq: '/services/rfq/exportBuyerServiceRfq',
  assignUserToServiceRfq: '/services/rfq/assignUser',
  unassignUserFromServiceRfq: '/services/rfq/unassignUser',
  getAssignedUsersForServiceRfq: '/services/rfq/getAssignedUsers',
  bulkAssignUsersToServiceRfq: '/services/rfq/bulkAssignUsers',
  assignUserToBuyerServiceRfq: '/services/rfq/buyerAssignUser',
  unassignUserFromBuyerServiceRfq: '/services/rfq/buyerUnassignUser',
  getAssignedUsersForBuyerServiceRfq: '/services/rfq/buyerGetAssignedUsers',
  bulkAssignUsersToBuyerServiceRfq: '/services/rfq/buyerBulkAssignUsers',
  generateSupplierServiceRfqAttachment: '/services/rfq/generateSupplierServiceRfqAttachment',
  fetchServiceRfqDetailsForExcel: '/services/rfq/fetchServiceRfqDetailsForExcel',
  fetchServiceRfqDetailPageData: '/services/rfq/fetchServiceRfqDetailPageData',
  fetchServiceRfqLineItemAttachments: '/services/rfq/fetchServiceRfqLineItemAttachments',
  acknowledgeServiceRfq: '/services/rfq/acknowledgeServiceRfq',
  declineServiceRfq: '/services/rfq/declineServiceRfq',
  getServiceQuoteId: '/services/rfq/getServiceQuoteId',
  getLastServiceQuoteId: '/services/rfq/getLastServiceQuoteId',
  saveServiceQuoteAsDraft: '/services/rfq/saveServiceQuoteAsDraft',
  updateServiceQuoteDraft: '/services/rfq/updateServiceQuoteDraft',
  getServiceQuoteDraftData: '/services/rfq/getServiceQuoteDraftData',
  fetchServiceRfqLineItemsForQuote: '/services/rfq/fetchServiceRfqLineItemsForQuote',
  fetchServiceQuoteDetailsBySupplierId: '/services/rfq/fetchServiceQuoteDetailsBySupplierId',
  serviceQuoteOperations: '/services/rfq/serviceQuoteOperations',
  assignUserToServiceQuotes: '/services/rfq/assignUserToServiceQuotes',
  fetchServiceQuoteAttachmentExcelData: '/services/rfq/fetchServiceQuoteAttachmentExcelData',
  generateServiceQuotationAttachment: '/services/rfq/generateServiceQuotationAttachment',
  fetchAllServiceQuotesByBuyerId: '/services/rfq/fetchAllServiceQuotesByBuyerId',
  buyerServiceQuoteOperations: '/services/rfq/buyerServiceQuoteOperations',
  fetchServiceQuoteLineItemsByBuyer: '/services/rfq/fetchServiceQuoteLineItemsByBuyer',
  assignUserToBuyerServiceQuotes: '/services/rfq/assignUserToBuyerServiceQuotes',
  fetchBuyerServiceQuoteExportAll: '/services/rfq/fetchBuyerServiceQuoteExportAll',
  fetchServiceQuoteDetailsForBuyer: '/services/rfq/fetchServiceQuoteDetailsForBuyer',
  fetchServiceQuoteListByRfqId: '/services/rfq/fetchServiceQuoteListByRfqId',
  createServicePurchaseOrder: '/services/rfq/createServicePurchaseOrder',
  fetchServicePurchaseOrder: '/services/rfq/fetchServicePurchaseOrder',
  updateServicePurchaseOrder: '/services/rfq/updateServicePurchaseOrder',
  updateServicePurchaseOrderFreightForwarder: '/services/rfq/updateServicePurchaseOrderFreightForwarder',
  sendServicePoConfirmationForBuyerAndSupplier: '/services/rfq/sendServicePoConfirmationForBuyerAndSupplier',
  fetchAllServicePurchaseOrderByBuyerId: '/services/rfq/fetchAllServicePurchaseOrderByBuyerId',
  servicePurchaseOrderListOperations: '/services/rfq/servicePurchaseOrderListOperations',
  generateServicePoPdf: '/services/rfq/generateServicePoPdf',
  fetchServicePoAttachmentExcelData: '/services/rfq/fetchServicePoAttachmentExcelData',
  assignServicePOToBuyerUser: '/services/rfq/assignServicePOToBuyerUser',
  fetchAllServicePurchaseOrderBySupplierId: '/services/rfq/fetchAllServicePurchaseOrderBySupplierId',
  supplierServicePurchaseOrderListOperations: '/services/rfq/supplierServicePurchaseOrderListOperations',
  sendServicePOConfirmationAcknowledgement: '/services/rfq/sendServicePOConfirmationAcknowledgement',
  sendServicePORejectionAcknowledgement: '/services/rfq/sendServicePORejectionAcknowledgement',
  getLastAcceptedServiceOrderId: '/services/rfq/getLastAcceptedServiceOrderId',
  fetchAllServiceRejectionReason: '/services/rfq/fetchAllServiceRejectionReason',
  createAndGetServiceInvoiceDetails: '/services/rfq/createAndGetServiceInvoiceDetails',
  sendServiceInvoice: '/services/rfq/sendServiceInvoice',
  generateServiceCommercialInvoicePdf: '/services/rfq/generateServiceCommercialInvoicePdf',
  generateServicePackingListPdf: '/services/rfq/generateServicePackingListPdf',
  generateServiceDeliveryNotePdf: '/services/rfq/generateServiceDeliveryNotePdf',
  generateServiceInvoicePdf: '/services/rfq/generateServiceInvoicePdf',
  fetchServiceInvoiceAttachmentExcelData: '/services/rfq/fetchServiceInvoiceAttachmentExcelData',
  fetchServiceInvoiceStatusSummaryByBuyerId: '/services/rfq/fetchServiceInvoiceStatusSummaryByBuyerId',
  fetchServiceInvoiceListsByBuyerId: '/services/rfq/fetchServiceInvoiceListsByBuyerId',
  fetchArchivedServiceInvoiceListByBuyerId: '/services/rfq/fetchArchivedServiceInvoiceListByBuyerId',
  exportAllServiceInvoiceListByBuyerId: '/services/rfq/exportAllServiceInvoiceListByBuyerId',
  addServiceInvoicePaymentDetails: '/services/rfq/addServiceInvoicePaymentDetails',
  serviceInvoiceListsOperations: '/services/rfq/serviceInvoiceListsOperations',
  uploadServicePOD: '/services/rfq/uploadServicePOD',

  // Supplier Service Invoice List
  fetchSupplierServiceInvoiceStatusSummary: '/services/rfq/fetchSupplierServiceInvoiceStatusSummary',
  fetchSupplierServiceInvoiceLists: '/services/rfq/fetchSupplierServiceInvoiceLists',
  fetchArchivedSupplierServiceInvoiceLists: '/services/rfq/fetchArchivedSupplierServiceInvoiceLists',
  exportAllSupplierServiceInvoiceList: '/services/rfq/exportAllSupplierServiceInvoiceList',
  supplierServiceInvoiceListsOperations: '/services/rfq/supplierServiceInvoiceListsOperations',
  // Service Dispatch
  createServiceDispatch: '/services/rfq/createServiceDispatch',
  submitServiceCompletion: '/services/rfq/submitServiceCompletion',
  fetchServiceCompletionReview: '/services/rfq/fetchServiceCompletionReview',
  sendServiceCompletionClarification: '/services/rfq/sendServiceCompletionClarification',
  acceptServiceCompletion: '/services/rfq/acceptServiceCompletion',
  fetchServiceDispatchDetailsByDispatchId: '/services/rfq/fetchServiceDispatchDetailsByDispatchId',
  fetchServiceDispatchDetailsByDispatchIdAndInvoiceId: '/services/rfq/fetchServiceDispatchDetailsByDispatchIdAndInvoiceId',
  deleteServiceDispatchAttachment: '/services/rfq/deleteServiceDispatchAttachment',
  fetchServiceInvoiceDetailsById: '/services/rfq/fetchServiceInvoiceDetailsById',
  fetchAllRfqBybuyerId: '/rfq/fetchAllRfqBybuyerId',
  // RFQ → Buyer↔Supplier KYC document request endpoints
  rfqKycRequestCreate:        '/rfq/kycRequest/create',
  rfqKycRequestUpload:        '/rfq/kycRequest/upload',
  rfqKycRequestSubmit:        '/rfq/kycRequest/submit',
  rfqKycRequestAccept:        '/rfq/kycRequest/accept',
  rfqKycRequestReject:        '/rfq/kycRequest/reject',
  rfqKycRequestGetByRfq:      '/rfq/kycRequest/byRfq',
  rfqKycRequestGetBySupplier: '/rfq/kycRequest/bySupplier',
  rfqKycRequestGetByBuyerSupplier: '/rfq/kycRequest/byBuyerSupplier',

  // -----------------------------------------------------------------------
  // Public KYC token submission endpoints (My Suppliers magic-link flow).
  // Mounted on the /rfq router without auth middleware — same pattern as
  // the existing /rfq/verify-rfq-token public endpoint. The supplier's
  // plain short token travels in the request body; the backend hashes
  // it with SHA-256 and validates against kycTokenDetails before
  // performing the requested action.
  // -----------------------------------------------------------------------
  kycTokenVerify:    '/rfq/kycToken/verify',
  kycTokenGetByToken:'/rfq/kycToken/getByToken',
  kycTokenUpload:    '/rfq/kycToken/upload',
  kycTokenSubmit:    '/rfq/kycToken/submit',
  rfqOperations: '/rfq/rfqOperations',
  rfqOperationsByRfqToken: '/rfq/rfqOperationsByRfqToken',
  buyerRfqOperations: '/rfq/buyerRfqOperations',
  quoteOperations:'/quote/quoteOperations',
  generateSupplierRfqAttachment: '/rfq/generateSupplierRfqAttachment',
  generateSupplierRfqAttachmentByRfqToken:
    '/rfq/generateSupplierRfqAttachmentByRfqToken',
  sendRfqRemindersByBuyer: '/rfq/sendRfqRemindersByBuyer',

  addPortAgent: '/buyer/addPortAgent',
  addFreightForwarder: '/buyer/addFreightForwarder',
  fetchPortAgentByUserId: '/buyer/fetchPortAgentByUserId',
  fetchFreightForwarderByUserId: '/buyer/fetchFreightForwarderByUserId',
  importPortAgent: '/buyer/portAgent/import',
  importFreightForwarder: '/buyer/freightForwarder/import',

  // on Supplier's user page
  importUsers: '/users/supplier/importusers',
  exportAllUsers: '/users/supplier/exportusers',

  importProducts: '/products/importProductsByAdmin',
  importSparePartsByAdmin: '/products/importSparePartsByAdmin',
  extractSparePartsFromCatalogue: '/products/extractSparePartsFromCatalogue',
  reviewImportedRfq: '/rfq/reviewImportedRfq',
  importProductsByBuyer: '/products/importProductsByBuyer',
  exportProducts: '/products/exportAllProducstByAdmin',
  exportAllProductsByBuyer: '/products/exportAllProductsByBuyer',
  exportAllImpaDataBySupplierId: '/settings/exportAllImpaDataBySupplierId',
  exportAllMarketPlaceDataBySupplierId: '/settings/exportAllMarketPlaceDataBySupplierId',
  importAllImpaDataBySupplierId: '/settings/importAllImpaDataBySupplierId',
  importMarketplaceProductDataBySupplierId:'/products/importSupplierMarketplaceProducts',
  exportAllServicesByAdmin: '/services/exportAllServicesByAdmin',
  exportAllServicesByBuyer: '/services/exportAllServicesByBuyer',
  importServicesByAdmin: '/services/importServicesByAdmin',
  importServicesByBuyer: '/services/importServicesByBuyer',
  importSuppliersBranches: '/supplier/importSuppliersBranches',
  exportServicesBySupplierId: '/services/exportServicesBySupplierId',
  importServicesBySupplierId: '/services/importServicesBySupplierId',
  exportAllCategoriesByAdmin:'/categories/exportAllCategoriesByAdmin',
  importCategoriesByAdmin:'/categories/importCategoriesByAdmin',
  importServiceCategoriesByAdmin:'/categories/importServiceCategoriesByAdmin',
  exportAllServiceCategoriesByAdmin:'/categories/exportAllServiceCategoriesByAdmin',
  exportAllBrandsByAdmin:'/brands/exportAllBrandsByAdmin',
  importBrandsByAdmin:'/brands/importBrandsByAdmin',

  fetchQuoteDetailsBySupplierId:'/quote/fetchQuoteDetailsBySupplierId',
  fetchAllQuotesByBuyerId:'/quote/fetchAllQuotesByBuyerId',
  fetchQuoteLineItemDetailsByQuoteId:'/quote/fetchQuoteLineItemsByQuoteId',
  generateQuoteAttachment: '/quote/generateQuotationAttachment',
  quoteOperationsByBUyer: '/quote/quoteOperationsByBUyer',
  fetchQuoteLossReasons: '/quote/fetchQuoteLossReasons',
  fetchQuoteOutcomeForSupplier: '/quote/fetchQuoteOutcomeForSupplier',
  // 2026-10-24 Batch B (P1 / P5 / P8)
  fetchCatalogueMatchesForRfq: '/quote/fetchCatalogueMatchesForRfq',
  myPortCoverage: '/port/myPortCoverage',
  adminPortCoverageReport: '/port/adminPortCoverageReport',
  generateRfqAttachmentForBuyer: '/rfq/generateBuyerRfqAttachment',

  getRoleData:'/userManagement/role/getRoleData',
  addRoleData:'/userManagement/role/addRoleData',
  updateRoleData:'/userManagement/role/updateRoleData',
  deleteOrRestoreRoleData:'/userManagement/role/deleteOrRestoreRoleData',

  getApprovalData:'/userManagement/approval/getApprovalData',
  deleteApprovalData:'/userManagement/approval/deleteApprovalData',
  updateApprovalData:'/userManagement/approval/updateApprovalData',
  addApprovalData:'/userManagement/approval/addApprovalData',
  addApprovalMappingData:'/userManagement/approvalMapping/addApprovalMappingData',
  updateApprovalMappingData:'/userManagement/approvalMapping/updateApprovalMappingData',
  getApprovalMappingData:'/userManagement/approvalMapping/getApprovalMappingData',
  deleteApprovalMappingData:'/userManagement/approvalMapping/deleteApprovalMappingData',
  getApprovalMappingById:'/userManagement/approvalMapping/getApprovalMappingById',
  assignPOApprovalToBuyerUser: '/users/assignPOApprovalToBuyerUser',
  getSupplierDashBoardData:'/supplier/getSupplierDashBoardData',
  getFilteredSupplierDashBoardRecentsTableData:'/supplier/getFilteredSupplierDashBoardRecentsTableData',
  getBuyerDashBoardData:'/buyer/getBuyerDashBoardData',
  getBuyerDashboardCustomData:'/buyer/getBuyerDashboardCustomData',
  getFilteredBuyerDashBoardRecentOrdersData:'/buyer/getFilteredBuyerDashBoardRecentOrdersData',
  getAdminDashboardKpis:'/adminDashboard/getAdminDashboardKpis',
  getAdminDashboardNewUsers:'/adminDashboard/getAdminDashboardNewUsers',
  getAdminDashboardTotalTransactions:'/adminDashboard/getAdminDashboardTotalTransactions',
  getAdminDashboardActivity:'/adminDashboard/getAdminDashboardActivity',
  getAdminDashboardActivityBreakdown:'/adminDashboard/getAdminDashboardActivityBreakdown',
  getAdminDashboardTopEntities:'/adminDashboard/getAdminDashboardTopEntities',
  getAdminDashboardRecentActivity:'/adminDashboard/getAdminDashboardRecentActivity',
  getAdminDashboardBootstrap:'/adminDashboard/bootstrap',
  getAdminDashboardTrend:'/adminDashboard/getAdminDashboardTrend',
  getAdminDashboardPoVsDeliveries:'/adminDashboard/getAdminDashboardPoVsDeliveries',
  getAdminNotifications:'/adminDashboard/getAdminNotifications',
  markAdminNotificationsRead:'/adminDashboard/markAdminNotificationsRead',
  getAdminNotificationsList:'/adminDashboard/getAdminNotificationsList',
  getAdminActivityFeed:'/adminDashboard/getAdminActivityFeed',
  // Admin Dashboard -> Invoicing tab -> "Supplier" segment (operational
  // product invoices of ALL suppliers). Author: Akarsh Singh | 2026-07-06
  getAdminSupplierInvoicesList:'/adminDashboard/getAdminSupplierInvoicesList',
  getAdminInvoiceSuppliersList:'/adminDashboard/getAdminInvoiceSuppliersList',
  getAdminSupplierInvoiceDetails:'/adminDashboard/getAdminSupplierInvoiceDetails',
  getAdminSupplierInvoiceStatusSummary:'/adminDashboard/getAdminSupplierInvoiceStatusSummary',
  // Admin Settings page (/admin/settings) — banking + invoicing defaults.
  // Author: Akarsh Singh | 2026-07-11
  getAdminPaymentSettings:'/adminDashboard/getAdminPaymentSettings',
  updateAdminPaymentSettings:'/adminDashboard/updateAdminPaymentSettings',
  // 2026-10-24 Batch B: dev mail redirect (platform admins only; inert on prod)
  getDevMailRedirect: '/adminDashboard/getDevMailRedirect',
  updateDevMailRedirect: '/adminDashboard/updateDevMailRedirect',
  // Invoice Controls (restriction flags only, any authenticated user).
  // Author: Akarsh Singh | 02-08-2026
  getInvoiceControls:'/adminDashboard/getInvoiceControls',
  // Buyer Vessel Invoicing (Invoicing tab -> Buyer segment).
  // Author: Akarsh Singh | 2026-07-14
  getBuyerInvoiceHistory:'/adminDashboard/getBuyerInvoiceHistory',
  getBuyerChargePreview:'/adminDashboard/getBuyerChargePreview',
  createBuyerInvoice:'/adminDashboard/createBuyerInvoice',
  getBuyerInvoicesList:'/adminDashboard/getBuyerInvoicesList',
  getBuyerInvoiceKpis:'/adminDashboard/getBuyerInvoiceKpis',
  getBuyerInvoiceDetails:'/adminDashboard/getBuyerInvoiceDetails',
  getBuyerInvoicePdf:'/adminDashboard/getBuyerInvoicePdf',
  sendBuyerInvoice:'/adminDashboard/sendBuyerInvoice',
  remindBuyerInvoice:'/adminDashboard/remindBuyerInvoice',
  markBuyerInvoicePaid:'/adminDashboard/markBuyerInvoicePaid',
  cancelBuyerInvoice:'/adminDashboard/cancelBuyerInvoice',
  getSupplierBillableOrders:'/adminDashboard/getSupplierBillableOrders',
  getSupplierCommissionHistory:'/adminDashboard/getSupplierCommissionHistory',
  createSupplierCommissionInvoice:'/adminDashboard/createSupplierCommissionInvoice',
  getSupplierCommissionInvoicesList:'/adminDashboard/getSupplierCommissionInvoicesList',
  getSupplierCommissionInvoiceKpis:'/adminDashboard/getSupplierCommissionInvoiceKpis',
  getSupplierCommissionInvoiceDetails:'/adminDashboard/getSupplierCommissionInvoiceDetails',
  getSupplierCommissionInvoicePdf:'/adminDashboard/getSupplierCommissionInvoicePdf',
  sendSupplierCommissionInvoice:'/adminDashboard/sendSupplierCommissionInvoice',
  remindSupplierCommissionInvoice:'/adminDashboard/remindSupplierCommissionInvoice',
  markSupplierCommissionInvoicePaid:'/adminDashboard/markSupplierCommissionInvoicePaid',
  cancelSupplierCommissionInvoice:'/adminDashboard/cancelSupplierCommissionInvoice',

  // Admin KYC
  adminKycGetQueue: '/adminDashboard/kyc/queue',
  adminKycGetFull: '/adminDashboard/kyc/application',
  adminKycGetDocuments: '/adminDashboard/kyc/documents',
  adminKycGetCertifications: '/adminDashboard/kyc/certifications',
  adminKycGetTimeline: '/adminDashboard/kyc/timeline',
  adminKycDecision: '/adminDashboard/kyc/decision',
  // MPS-263 KYC-102 — the admin's individual verification checks.
  adminKycSaveCheck: '/adminDashboard/kyc/check',
  adminKycGetChecks: '/adminDashboard/kyc/checks',

  createAndGetInvoiceDetails: '/supplier/createAndGetInvoiceDetails',
  sendInvoice: '/supplier/sendInvoice',
  uploadPOD: '/supplier/uploadPOD',
  generateCommercialInvoicePdf: '/supplier/generateCommercialInvoicePdf',
  generatePackingListPdf: '/supplier/generatePackingListPdf',
  generateDeliveryNotePdf: '/supplier/generateDeliveryNotePdf',
  fetchInvoicesListBySupplierId: '/supplier/fetchInvoicesListBySupplierId',
  fetchArchivedInvoicesListBySupplierId: '/supplier/fetchArchivedInvoicesListBySupplierId',
  invoiceListsOperations: '/supplier/invoiceListsOperations',
  exportAllInvoiceListBySupplierId: '/supplier/exportAllInvoiceListBySupplierId',
  // Supplier invoices
  fetchInvoiceStatusSummaryBySupplierId: '/supplier/fetchInvoiceStatusSummaryBySupplierId',
  // Buyer invoices
  fetchInvoiceStatusSummaryByBuyerId: '/buyer/fetchInvoiceStatusSummaryByBuyerId',
  fetchInvoicesListByBuyerId: '/buyer/fetchInvoicesListByBuyerId',
  fetchArchivedInvoicesListByBuyerId: '/buyer/fetchArchivedInvoicesListByBuyerId',
  exportAllInvoiceListByBuyerId: '/buyer/exportAllInvoiceListByBuyerId',
  // Invoice payments
  addInvoicePaymentDetails: '/buyer/addInvoicePaymentDetails',
  removePaymentProof: '/buyer/removePaymentProof',

  // Buyer notification settings
  getBuyerNotificationSettings: '/settings/buyer/fetchBuyerNotificationSettings',
  createBuyerNotificationSettings: '/settings/buyer/createBuyerNotificationSettings',
  updateBuyerNotificationSettings: '/settings/buyer/updateBuyerNotificationSettings',

  // Supplier notification settings
  fetchSupplierNotificationSettings: '/settings/supplier/fetchSupplierNotificationSettings',
  createSupplierNotificationSettings: '/settings/supplier/createSupplierNotificationSettings',
  updateSupplierNotificationSettings: '/settings/supplier/updateSupplierNotificationSettings',
  // Up to five "Also, get notified on" addresses per supplier.
  // Akarsh Singh | 2026-10-17
  fetchSupplierNotificationEmails: '/settings/supplier/fetchSupplierNotificationEmails',
  saveSupplierNotificationEmails: '/settings/supplier/saveSupplierNotificationEmails',
  fetchBuyerNotificationEmails: '/settings/buyer/fetchBuyerNotificationEmails',
  saveBuyerNotificationEmails: '/settings/buyer/saveBuyerNotificationEmails',

  fetchInvoiceDataById: '/supplier/fetchInvoiceDetailsByInvoiceId',
  createDispatch: '/supplier/createDispatch',
  confirmOrderReceipt:'/buyer/createConfirmOrderReceipt',

  fetchSupplierRfqAttachmentExcelData:"/rfq/fetchSupplierRfqAttachmentExcelData",
  fetchBuyerRfqAttachmentExcelData :"/rfq/fetchBuyerRfqAttachmentExcelData",
  fetchQuoteAttachmentExcelData:"/quote/fetchQuoteAttachmentExcelData",

  // Buyer notifications
  fetchBuyerNotificationsByBuyerId: '/buyer/fetchBuyerNotificationsByBuyerId',
  buyerNotificationsOperations: '/buyer/notificationsOperations',
  markBuyerNotificationAsRead: '/buyer/markBuyerNotificationAsRead',
  markAllBuyerNotificationsAsRead: '/buyer/markAllBuyerNotificationsAsRead',
  // New GET route for buyer notifications list
  getBuyerNotifications: '/buyer/getBuyerNotifications',

  // Supplier notifications
  fetchSupplierNotificationsBySupplierId: '/supplier/fetchSupplierNotificationsBySupplierId',
  supplierNotificationsOperations: '/supplier/notificationsOperations',
  markSupplierNotificationAsRead: '/supplier/markSupplierNotificationAsRead',
  markAllSupplierNotificationsAsRead: '/supplier/markAllSupplierNotificationsAsRead',
  // New GET route for supplier notifications list
  getSupplierNotifications: '/supplier/getSupplierNotifications',

  getSupplierDashBoardTopBuyersData: '/supplier/getSupplierDashBoardTopBuyersData',
  getSupplierDashBoardQuoteSuccessRateByProduct:'/supplier/getSupplierDashBoardQuoteSuccessRateByProduct',
  getSupplierDashBoardPerfomanceScoreData:'/supplier/getSupplierDashBoardPerfomanceScoreData',
  getSupplierDashBoardRfqResponseChartData: '/supplier/getSupplierDashBoardRfqResponseChartData',
  getSupplierDashBoardRfqResponseChartDataCustom: '/supplier/getSupplierDashBoardRfqResponseChartDataCustom',
  getSupplierDashboardCustomData: '/supplier/getSupplierDashboardCustomData',
  getBuyerDashBoardSupplierPerfomanceChartData:"/buyer/getBuyerDashBoardSupplierPerfomanceChartData",
  getBuyerDashBoardSpendingByProductCategoryData:'/buyer/getBuyerDashBoardSpendingByProductCategoryData',
  getSupplierDashBoardRevenuByProductCategoryData: '/supplier/getSupplierDashBoardRevenuByProductCategoryData',
  getAdminDashboardDocumentList:'/adminDashboard/getAdminDashboardDocumentList',

  // MPS-212  Supplier KYC Document Setup (buyer catalogue)
  supplierKycDocTitles:    '/supplierKycDoc/titles',
  supplierKycDocTitleById: '/supplierKycDoc/titles',  // append /:id

  // Company compliance exemption (trial / subscription)
  complianceExemptionMe:            '/users/complianceExemption/me',
  complianceExemptionByUser:        '/adminDashboard/complianceExemption/byUser',   // append /:userId
  complianceExemptionByCompany:     '/adminDashboard/complianceExemption/company',  // append /:companyId
  complianceExemptionEndedTrials:   '/adminDashboard/complianceExemption/endedTrials',
  complianceExemptionUpsert:        '/adminDashboard/complianceExemption/upsert',
  complianceExemptionDisable:       '/adminDashboard/complianceExemption/disable',
  complianceExemptionRestoreGates:  '/adminDashboard/complianceExemption/restoreGates',
};
